export class SalesDetailsModel {
    sale_active: boolean;
    start_date: string;
    end_date: string;
    start_time: string;
    end_time: string;
    sale_days: string;
    sale_percent: number;
    category: string;

    constructor(
        sale_active: boolean,
        start_date: string,
        end_date: string,
        start_time: string,
        end_time: string,
        sale_days: string,
        sale_percent: number,
        category: string
    ) {
        this.sale_active = sale_active;
        this.start_date = start_date;
        this.end_date = end_date;
        this.start_time = start_time;
        this.end_time = end_time;
        this.sale_days = sale_days;
        this.sale_percent = sale_percent;
        this.category = category;
    }
}
    